import { Alert } from '@ver-uds/uswds-react';
import React from 'react';

export const ConfirmationRequired = ({ email }: { email?: string }): JSX.Element => {
  return (
    <section>
      <h1 data-testid="check-your-email">Check your Email</h1>
      <div className="padding-bottom-1 grid-col-10">
        <p className="usa-intro">
          Within a few minutes you should receive an email
          {email ? (
            <>
              {' '}
              at <b>{email}</b>
            </>
          ) : null}{' '}
          with your activation link. Note your link will expire in 24 hours.
        </p>
      </div>
      <Alert status="info" slim>
        <Alert.Text className="grid-col-9">
          Please check email inboxes as well as spam or junk mail folders for emails sent from no‑reply@uscis.dhs.gov,
          as sometimes the emails are mistakenly marked as spam. If you do not receive the confirmation email, contact{' '}
          <a
            href="mailto:E-Verify@uscis.dhs.gov"
            rel="noopener noreferrer"
            target="_blank"
            aria-label="Send an email to E-Verify@uscis.dhs.gov"
          >
            E-Verify@uscis.dhs.gov
          </a>{' '}
          for assistance.
        </Alert.Text>
      </Alert>
    </section>
  );
};

ConfirmationRequired.defaultProps = {
  email: '',
};

export default ConfirmationRequired;
